





























import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { NavBar, Row, Icon, NoticeBar } from "vant";
import WeMixin from "@/components/weMixin";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
  },
})
export default class ErrorPage extends mixins(WeMixin) {
  @Prop({ default: "404" })
  private message!: string;
  @Prop({ default: "页面出错了" })
  private title!: string;
  private tips!: string;

  protected created() {
    const reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
    if (!reg.test(this.$route.query.tips as string)) {
      this.tips = this.$route.query.tips as string;
    }
  }

  get msg() {
    const reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
    if (!reg.test(this.$route.query.tips as string)) {
      if (this.$route.query.message) {
        return this.$route.query.message as string;
      } else {
        return this.message;
      }
    }
  }
}
